export const CampaignArtworkSuggestionEnum = {
  Link: {
    key: 1,
  },
  File: {
    key: 2,
  },
};
